import React, { useContext } from "react";
import Alcance from "./Alcance";
import Conclusiones from "./Conclusiones";
import Consideraciones from './Consideraciones';
import ConsultaFabricantesCPEs from "./ConsultaFabricantesCPEs";
import EncuestaISPs from "./EncuestaISPs";
import Introduccion from "./Introduccion";
import IPv4AndServices from './IPv4AndServices'
import MecanismosDeTransicion from './MecanismosDeTransicion'
import Motivo from "./Motivo";
import Objetivo from "./Objetivo";
import RecoleccionInformacion from "./RecoleccionInformacion";
import Referencias from "./Referencias";
import Resumen from "./Resumen"; 
import { LangContext } from "../../../../context/DataContext";

export default function IPv6EnEquiposCPE() {
 
    return ( 
      <> 
        <ReportTitle />
        <Resumen/>
        <Objetivo />
        <Motivo />
        <Alcance />
        <Introduccion />
        <Consideraciones />
        <MecanismosDeTransicion />
        <IPv4AndServices />
        <RecoleccionInformacion />
        <EncuestaISPs/>
        <ConsultaFabricantesCPEs />
        <Conclusiones />
        <Referencias />
      </>
    )
}
 
function ReportTitle() {
  const { myLang } = useContext(LangContext)
  return (
    <h1>
        {myLang === 'es' && 'Informe sobre soporte de IPv6 en equipos CPE - Versión 1 (2020)'}
        {myLang === 'en' && 'Informe sobre soporte de IPv6 en equipos CPE - Versión 1 (2020)'}
        {myLang === 'pt' && 'Informe sobre soporte de IPv6 en equipos CPE - Versión 1 (2020)'}
    </h1>
    )
}